import { FirstBetValues, trackingConstants } from '@frontend/sports/tracking/feature';

import { BetslipType } from '../../core/betslip-type';
import { BetslipPick } from '../../core/picks/betslip-pick';

export enum PickTypeTracking {
    Race = 'Race',
    Sport = 'Sport',
    BetBuilder = 'BetBuilder',
}

export enum PriceTypeTracking {
    Fixed = 'FixedOdds',
    StartingPrice = 'SP',
    NoPrice = '',
}

export interface BetSourceTracking {
    live: { [key: string]: number };
    main: { [key: string]: number };
}

export enum RewardTokenTracking {
    FreeBet = 'FreeBet',
    OddsBoost = 'OddsBoost',
    RiskFree = 'RiskFree',
    AccaBoost = 'AccaBoost',
}

export enum BetslipNavigationTracking {
    Click = 'click',
    TrackingLabelEvent = 'betslip navigation',
    TrackingSource = 'betslip',
    TrackingPositionEvent = 'betslip tabs',
    TrackingPositionTabEvent = 'tab',
    TrackingLabelPodEvent = 'build a bet market pod',
}

export enum EntainUiBetBuilderPickRemovalTracking {
    Click = 'click',
    TrackingSource = 'betslip',
    TrackingSinglePickRemoval = 'delete one selection',
    TrackingAllPickRemovalSgp = 'delete all selections',
    TrackingDeleteConfirmation = 'confirm delete all',
    TrackingAllPickRemovalBetslip = 'delete all',
    TrackingEventDetails = 'bet builder',
    TrackingEventName = 'betting',
}

export interface BetslipTrackingData {
    action?: string;
    position?: number;
    eventDetails?: string;
    positionEvent?: string;
    isLinear?: boolean;
}

export enum BetslipErrorTracking {
    Load = 'load',
    TrackingCategoryEvent = 'betslip',
    TrackingLabelEvent = 'full betslip',
    TrackingLocationEvent = 'tabbed betslip',
}
export enum TransactionAffiliate {
    Livebook = 'Livebook',
    Mainbook = 'Mainbook',
    MainAndLive = 'Livebook/Mainbook',
}

export interface TrackAddRemoveBet {
    name?: string;
    category?: string;
    price?: number;
    transactionId: string;
    transactionProducts: TrackBetslipPick;
    quantity?: number;
    transactionAffiliation?: string;
    sku?: string;
    insurance?: string;
    bet_details?: string;
    sport_id?: number;
    market_id?: number;
    league_id?: number;
    result_id?: number;
    betType?: string;
    [trackingConstants.PRODUCT_PICK_DETAILS]: string;
}
export interface TrackBetslipPick {
    name: string;
    category: string;
    betslipID?: string;
    betRequestID?: string;
    systemBetType?: string;
    transactionAffiliate?: TransactionAffiliate;
    transactionAffiliation?: string;
    insurance?: string;
    quantity: number;
    price: number;
    sku: string;
    odds?: string;
    bet_details?: string;
    variant?: string;
    bet_calendar?: string;
    transactionId?: string;
    [trackingConstants.COMPONENT_CATEGORY_EVENT]: string | undefined;
    [trackingConstants.COMPONENT_LABEL_EVENT]: string | undefined;
    [trackingConstants.COMPONENT_POSITION_EVENT]: string | undefined;
    [trackingConstants.COMPONENT_EVENT_DETAILS]: string | undefined;
    [trackingConstants.COMPONENT_URL_CLICKED]: string | undefined;
    [trackingConstants.COMPONENT_ACTION_EVENT]: string | undefined;
    [trackingConstants.COMPONENT_LOCATION_EVENT]: string | undefined;
    [trackingConstants.QUICKBET]: string | undefined;
    [trackingConstants.COMPONENT_CONTENT_POSITION]: string | number | undefined;
    [trackingConstants.BET_TYPE]: string | undefined;
    [trackingConstants.RESULT_ID]: string | undefined;
    [trackingConstants.SPORT_ID]: any;
    [trackingConstants.MARKET_ID]: string | undefined;
    [trackingConstants.SPORT_LEAGUE_ID]: string | undefined;
    [trackingConstants.PRODUCT_PICK_DETAILS]: string | undefined;
    [trackingConstants.COMPONENT_BET_SOURCE]: string | undefined;
    [trackingConstants.COMPONENT_MODULE_TYPE]: string | undefined;
    [trackingConstants.GAME_DETAILS]: string | undefined;
    [trackingConstants.BET_TRACKING_TYPE]: string | undefined;
    [trackingConstants.BET_PICK_TYPE]: string | undefined;
}
export interface TrackEntainUiBetBuilderPickRemoval {
    [trackingConstants.COMPONENT_CATEGORY_EVENT]: string | undefined;
    [trackingConstants.COMPONENT_LABEL_EVENT]: string | undefined;
    [trackingConstants.COMPONENT_ACTION_EVENT]: string | undefined;
    [trackingConstants.COMPONENT_POSITION_EVENT]: string | undefined;
    [trackingConstants.COMPONENT_LOCATION_EVENT]: string | undefined;
    [trackingConstants.COMPONENT_EVENT_DETAILS]: string | undefined;
    [trackingConstants.COMPONENT_URL_CLICKED]: string | undefined;
}
export interface TrackPlaceBet {
    transactionId: string;
    transactionAffiliation: string;
    transactionTotal: number;
    transactionProducts: TrackBetslipPick[];
    numberOfBets: number;
    currencyCode: string;
    oddsSettings?: string;
    [trackingConstants.PAGE_NAME]: string;
    [trackingConstants.PRODUCT_BET_SPORTS]: string;
    [trackingConstants.CART_PURCHASE]: string;
    [trackingConstants.CART_CHECKOUT]: string;
    [trackingConstants.TRANSACTION_PRODUCT_ODDS]: string;
    [trackingConstants.COMPONENT_SLIP_ID]?: string | undefined;
    [trackingConstants.BETSLIP_TYPE]: string;
    betRequestID?: string;
    [trackingConstants.COMPONENT_EVENT_POSITION]: FirstBetValues | undefined;
}

export interface TrackingSlipData {
    type: BetslipType | null;
    picks: BetslipPick[];
    stake: number | null;
}
